// import React from 'react'


// const SimpleDeleteModal = (
//     { isOpen,
//         title,
//         description,
//         onDelete,
//         onCancel, buttonName, icon, }) => {
//     if (!isOpen) return null
//     return (
//         <div>
//             <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//                 <div className="bg-white rounded-lg shadow-lg w-[35rem]">
//                     <div className='w-full border-b'>
//                         <div className="flex items-center justify-between p-6 pb-2 border-b">
//                             <h3 className="text-lg font-semibold">{title}</h3>
//                             <button
//                                 className="w-10 h-10 text-2xl text-gray-500 bg-gray-100 rounded-full hover:text-gray-800"
//                                 onClick={onCancel}
//                             >
//                                 &times;
//                             </button>
//                         </div>
//                     </div>

//                     <div className="p-4 mt-6 space-y-6 ">
//                         <h2>{title}</h2>
//                         <p>{description}</p>

//                     </div>
//                     <div className="flex justify-end p-4 mt-6 space-x-3 border-t">
//                         <button
//                             className="px-6 py-2 border border-[#B8B8D2] text-gray-700 rounded hover:bg-gray-300"
//                             onClick={onCancel}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             className="px-6 py-2 text-white bg-purple-600 rounded hover:bg-purple-700"
//                             onClick={onDelete}
//                         >
//                             {buttonName ? buttonName : 'Delete'}
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default SimpleDeleteModal



import React from 'react';
import { X } from 'lucide-react';
import { MdDeleteForever } from "react-icons/md";

const SimpleDeleteModal = ({
    isOpen,
    title = "Are you sure ?",
    description = "That action cannot be reversed.",
    onDelete,
    onCancel,
    buttonName = "Delete",
    icon,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-lg w-[30rem] p-6">
                <div className="flex items-center justify-between pb-4">
                    <h3 className="text-lg font-semibold">Delete Confirmation</h3>
                    <button
                        className="flex items-center justify-center w-8 h-8 text-gray-500 rounded-full hover:bg-gray-200"
                        onClick={onCancel}
                    >
                        <X size={20} />
                    </button>
                </div>
                <div className="flex flex-col items-center p-4 space-y-4 text-center">
                    <div className="p-4 bg-red-100 rounded-full">
                        {icon || <span className="text-4xl text-red-500"><MdDeleteForever /></span>}
                    </div>
                    <h2 className="text-xl font-semibold">{title}</h2>
                    <p className="text-gray-500">{description}</p>
                </div>
                <div className="flex justify-center pt-4 mt-6 space-x-3 border-t">
                    <button
                        className="px-6 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-200"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-6 py-2 text-white bg-purple-600 rounded-lg hover:bg-purple-700"
                        onClick={onDelete}
                    >
                        {buttonName}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SimpleDeleteModal;